import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { AuthService } from '@services/auth.service';
import { of, switchMap } from 'rxjs';

export const noRedirectAuthGuard: CanActivateFn = () => {
    const authService: AuthService = inject(AuthService);
    const navController: NavController = inject(NavController);

    return authService.checkAuthentication().pipe(
        switchMap((authenticated) => {
            // Not authenticated
            if (!authenticated) {
                return of(true);
            }

            // Check if user is banned
            if (authService.user.is_banned) {
                navController.navigateRoot('/banned');
                return of(true);
            }

            // Authenticated
            return of(true);
        })
    );
};
